export class GraphEdge {
  constructor(from, to) {
    this.from = from
    this.to = to
  }
}
